import React, { Suspense, lazy } from 'react'
import { usePredictContext } from '../../context/PredictContextProvider'
import HeatMapGPT5 from './Crypto/HeatMapGPT5'
import BreakoutStructure from './Crypto/BreakoutStructure'

const TechnicalParserV2 = lazy(() => import('./Crypto/TechnicalParser').then(m => ({ default: m.TechnicalParserV2 })))
const SentimentalParser = lazy(() => import('./Crypto/SentiParser').then(m => ({ default: m.SentimentalParser })))
const IndicatorParser = lazy(() => import('./Crypto/IndicatorParser'))
const MultiTimeFrameParser = lazy(() => import('./Forex/MultiTimeFrameParser'))
const TechnicalV6Parser = lazy(() => import('./Crypto/Technical-V6-Parser'))
const TechnicalV7_2Parser = lazy(() => import('./Crypto/Technical-V7.2-Parser'))
const Indicator2Parser = lazy(() => import('./Crypto/Indicator2Parser'))
const Indicator8Parser = lazy(() => import('./Crypto/Indicator-V8-Parser'))
const Indicator5Parser = lazy(() => import('./Crypto/Indicator5Parser'))
const ForexTechnicalIndicator = lazy(() => import('./Forex/ForexTechnicalIndicator'))

const parserRegistry = {
    crypto: {
        'technical-market-analysis': TechnicalParserV2,
        'technical-sentiment': SentimentalParser,
        'technical-market-indicator': IndicatorParser,
        'technical-market-analysis-v6': TechnicalV6Parser,
        'technical-market-analysis-v7.2': TechnicalV7_2Parser,
        'technical-market-indicator-2': Indicator2Parser,
        'technical-market-indicator-8': Indicator8Parser,
        'as-c-indicator-5': Indicator5Parser,
        'as-c-heatmap-gpt5.1': HeatMapGPT5,
        'as-c-v6.3': BreakoutStructure,
    },
    forex: {
        'multi-timeframe-forex': MultiTimeFrameParser,
        "technical-indicator-forex": ForexTechnicalIndicator,
    },
}

const RenderAnalyze = ({ markdown, advance }) => {
    const { assistant, responseType } = usePredictContext()

    if (!markdown || !assistant?.assistant) return null

    const { tickerCase: assistantCase, value } = assistant.assistant
    const CaseMap = parserRegistry[assistantCase]
    const ParserComponent = CaseMap ? CaseMap[value] : null

    if (!ParserComponent) return null

    return (
        <Suspense fallback={<div>Loading analysis...</div>}>
            <ParserComponent markdown={markdown} advance={advance} responseType={responseType} />
        </Suspense>
    )
}

export default RenderAnalyze
